import { ShopCode } from '@/utils/shop'
import { ABTestInputCondition, abTestGlobalKey } from '../abtestV2'

export const PDP_GAME_EXPERIMENT_CAMPAIGN: ABTestInputCondition = {
  code: 'pdp_game_experiment_campaign',
  exprId: 'pdp_game_experiment',
  exprName: 'PDP Waiting Game Experiment',

  startDate: '2026-08-04T00:00:00Z',
  stopDate: '2026-11-04T23:59:59Z',
  endDate: '2026-11-04T23:59:59Z',

  endIfPurchased: false,

  trafficRate: 1,
  variants: [
    { code: abTestGlobalKey.groupControl, rate: 0.5 },
    { code: abTestGlobalKey.groupTreatment, rate: 0.5 },
  ],

  allowedDevices: [],
  allowedCountries: [],
  allowedStores: [ShopCode.SUN],

  allowedUrls: [
  "10111110226scl1cle1tr04cu03an01ppc1_ipatufml00377",
  "10181040226scl1cle1tu08nh02tr15wll1_ipatudth002166666",
  "10178240226scl1cle1tu08ph01ha13fsp2_ipatudth00242",
  "10727270226scl1cle1tr04nh02an01kwc1_ipatuats00161",
  "10688280226scl1cle1tu08ha07an01anl1_ipatudog00726",
  "10817030326scl1cle1ph08th07an01hsp1_ipatugrm00311_prompt_1",
  "10817030326scl1cle1ph08th07an01hsp1_ipatugrm00311_prompt_2",
  "10817030326scl1cle1ph08th07an01hsp1_ipatugrm00311_prompt_3",
  "10817030326scl1cle1ph08th07an01hsp1_ipatugrm00311_prompt_4",
  "10817030326scl1cle1ph08th07an01hsp1_ipatugrm00311_prompt_5",
  "10718040326scl1tmm1tr04nh02an01hsp1_ipatumcr00086_prompt_5",
  "10170050326scl1cle1tr04ha09an01hsp1_ipatufml00383",
  "10761030326scl1cle1tu08cu03li09bwc1_ipatudth00254",
  "10252030326scl1cle1tr04cu03li09bwc1_ipatuats00168",
  "10173170126scl1cle1tr04nh02an01smp1_ipatufml00358",
  "10207160326scl1tmm1ph08ha07an01cms1_ipatuvtr00640",
  "10257200326scl1cle1tr04ph01th12ppc1_ipatufth00558",
  "10425200326scl1cle1tr04cu03th12clc1_ipatufth00561",
  "10164310326scl1cle1ph08nh02tr15hsp1_ipatubid00029",
  "10193310326scl1cle1ph08ha09tr15s040_ipatubid00026",
  "10381310326scl1cle1tr04ha09tr15anl1_ipatucpl01066",
  "10492020426scl1cle1ph08ha09li09tow1_ipatugrm00359",
  "10939020426scl1cle1ph08th07an01s040_ipatuwsk00140",
  "10858020426scl1cle1ph08ha09an01s040_ipatuplc00151",
  "10284030426scl1cle1tu08cu03li09dwc1_ipatudog00841",
  "10395040426scl1cle1tr04ha09th12hsp1_ipatufth00578",
  "10280060426scl1cle1tu08th07li09tbl1_ipatudog00855",
  "10728060426scl1cle1tr04cu03th12phc4_ipatuhlc00330",
  "10719060426scl1cle1tr04nh02th12tbl1_ipatuhlc00331",
  "10694080426scl1cle1tr04th07an01hsp1_ipatufth00591",
  "10391060426scl1cle1tu08ph01li09aep1_ipatudog00854",
  "10593080426scl1cle1tr04ha07li09hsp1_ipatucrl00056",
  "10324100426scl1cle1tu08cu03li09aos1_ipatudog00877",
  "10863080426scl1cle1tr04ha09an01hsp1_ipatufth00593",
  "10411130426scl1cle1tr04ph01my04aos1_ipatufth00614",
  "10844170426scl1cle1ph08nh02ha12hsp1_ipatubik00110",
  "10220210426scl1cle1ph08cu03ng21ptw1_ipatubak00167",
  "10474220426scl1cle1tu08ha07ha12hsp1_ipatubsb00088",
  "10866220426scl1cle1ph08nh02ha12tbl1_ipatubet00190",
  "10102220426scl1cle1tr04cu03ha12plk1_ipatucrl00059",
  "10541220426scl1cle1tu08ha07ha12plk1_ipatuvlb00020",
  "10160230426scl1cle1tu08cu03an01ppc1_ipatudog00940",
  "10130110426scl1cle1tr04cu03ha12tot1_ipatutch00094",
  "10858240426scl1cle1tu08ha07an01hsp1_ipatudog00943",
  "10430280426scl1cle1tr04cu03my04apt1_ipatucpl01095",
  "10361280426scl1cle1ph08cu03my04apt1_ipatugrm00393",
  "10919280426scl1cle1tr04cu03my04apt1_ipatukid00644_prompt_1",
  "10919280426scl1cle1tr04cu03my04apt1_ipatukid00644_prompt_2",
  "10510290426scl1cle1tr04ha07ha12lws1_ipatugdn00166",
  "10831290426scl1cle1tu08ha07ha12sol1_ipatudog00961",
  "10930040526scl1cle1ph08nh02an01hsp1_ipatugrd00157",
  "10437040526scl1cle1tr04cu03ha13asr1_ipatukid00651",
  "10867040526scl1cle1ph08cu03ha13csm1_ipatuclg00074",
  "10568050526scl1cle1tr04nh02an01pos2_ipatucpl01107",
  "10216050526scl1cle1tu08ha07my04ccw1_ipatudog00973",
  "10535040526scl1cle1tu08nh02ha13asr1_ipatudog00966_prompt_1",
  "10535040526scl1cle1tu08nh02ha13asr1_ipatudog00966_prompt_2",
  "10676060526scl1cle1tr04ha07my04hsp1_ipatufth00708_prompt_1",
  "10676060526scl1cle1tr04ha07my04hsp1_ipatufth00708_prompt_2",
  "10412060526scl1cle1tr04cu03my04apt1_ipatufth00710_prompt_1",
  "10412060526scl1cle1tr04cu03my04apt1_ipatufth00710_prompt_2",
  "10671070526scl1cle1tu08nh02my04tot1_ipatudog00984",
  "10831090526scl1cle1tr04nh02my04hsp1_ipatuhut00458",
  "10282090526scl1cle1tr04th07my04hsp1_ipatufth00766",
  "10298090526scl1cle1ph08nh02my04hsp1_ipatuvtr00657",
  "10606090526scl1cle1tr04ha07ha12lbf2_ipatufth00759",
  "10554120526scl1cle1ph08nh02ha12hsp1_ipatufft00102",
  "10369120526scl1cle1tu08ha07ha12hsp1_ipatugof00195",
  "10542130526scl1cle1tu08nh02ha12hsp1_ipatufsh00262",
  "10286150526scl1cle1tr04cu03li09ltw1_ipatufth00858",
  "10585150526scl1cle1ph08cu03ha12plk1_ipatuslv00106",
  "10974160526scl1cle1ph08ha07ha12plk1_ipatuslv00107",
  "10630180526scl1cle1tr04cu03an01slt1_ipatutvl00037",
  "10306220526scl1cle1tr04ha07ha12hsp1_ipatufth00934",
  "10449220526scl1cle1tr04cu03ha12cms1_ipatucpl01133",
  "10834270526scl1tmr1tr04ha07ha12wop1_ipatucps00048",
  "10202280526scl1cle1tr04cu03ng21ckr1_ipatufth01023",
  "10109290526scl1ris1ph08nh02my04apt1_ipatuwed00262",
  "10949280526scl1cle1tu08cu03ng21ppc1_ipatufsh00276",
  "10350010626scl1cle1tr04nh02ng21hsp1_ipatuscb00040",
  "10950090626scl1cle1ph08ha07an01hsp1_ipatubet00199",
  "10545050626scl1ris1ph08cu03ha13acd1_ipatuwed00297",
  "10197110626scl1cle1tu08ha07my04mpc1_ipatudog01098",
  "10129110626scl1cle1ph08ha07my04mpc1_ipatuclg00081",
  "10330130626scl1cle1tu08ha07ha13dnf1_ipatudog01111_prompt_1",
  "10330130626scl1cle1tu08ha07ha13dnf1_ipatudog01111_prompt_2",
  "10352160626scl1cle1ph08nh02my04hsp1_ipatuwea00003",
  "10295160626scl1cle1tr04ha09li09pfg1_ipatucpl01184",
  "10357180626scl1cle1tr04th07ha12pws1_ipatufml00410",
  "10161260626scl1cle1ph08cu03ng21pfg1_ipatubid00073",
  "10212260626scl1cle1ph08cu03ng21dap1_ipatubid00076",
  "10826270626scl1cle1tu08nh02ng21hmm1_ipatudog01179",
  "10694250626scl1cle1tu08nh02ng21str1_ipatudog01171",
  "10861030226scl1cle1ph08ha07an01ljn1_ipatugod0062222",
  "10828130726scl1cle1tr04nh02tr15sfb1_ipatunbn00024",
  "10790130726scl1cle1tr04th07tr15lto1_ipatuwic00552",
  "10109130726scl1cle1tu08ha07tr15sdp1_ipatudog01230",
  "10293130726scl1cle1tu08ha07li09wss1_ipatudth00377",
  "10176130726scl1cle1tu08th07du10wfs1_ipatuftb00110",
  "10696130726scl1cle1tr04nh02tr15wfs1_ipatucrc00066",
  "10115130726scl1cle1ph08ha07tr18scb1_ipatuchc00001",
  "10716130726scl1cle1ph08nh02tr18scb1_ipatuazm00011_prompt_1",
  "10716130726scl1cle1ph08nh02tr18scb1_ipatuazm00011_prompt_2",
  "10859130726scl1cle1tr04th07tr15krd1_ipatukid00820",
  "10705130726scl1cle1tr04ha07tr15lto1_ipatucrc00065",
  "10159140726scl1cle1tr04th07ha12rsb1_ipatukid00841",
  "10895140726scl1cle1tr04nh02tr15rsb1_ipatutch00340",
  "10630140726scl1cle1tu08nh02tr15cbb1_ipatudog01232",
  "10415140726scl1cle1ph08th07tr15rsb1_ipatuslv00131",
  "10113140726scl1cle1tr04cu03ha12rsb1_ipatubok00249",
  "10637140726scl1cle1ph08cu03li09aos1_ipatubrc00206",
  "10129140726scl1cle1tr04nh02ha12lto1_ipatutch00357",
  "10616150726scl1cle1ph08cu03du10ewc1_ipatubid00120",
  "10903150726scl1cle1tr04cu03ha12anl1_ipatucpl01226",
  "10476150726scl1cle1tr04nh02my04fsp2_ipatukid00849_prompt_1",
  "10476150726scl1cle1tr04nh02my04fsp2_ipatukid00849_prompt_2",
  "10336150726scl1cle1tr04nh02ha12lto1_ipatumth00910",
  "10151140726scl1cle1ph08th07ha12scb1_ipatubid00088",
  "10426150726scl1cle1tu08nh02li09plp1_ipatudog01234",
  "10582130726scl1cle1ph08cu03tr15lto1_ipatucwg00240_leather-bag",
  "10582130726scl1cle1ph08cu03tr15lto1_ipatucwg00240_combo",
  "10582130726scl1cle1ph08cu03tr15lto1_ipatucwg00240_plush-keychain",
  "10907150726scl1tmr1tr04th07tr15ckj1_ipatucps00112",
  "10790150726scl1cle1tr04nh02my01dap1_ipatucpl01228",
  "10311150726scl1cle1ph08ha07du10ewc1_ipatugod00762",
  "10907250326scl1cle1tr04nh02ha12wws1_ipatubtd00002",
  "10105160726scl1cle1tr04nh02tr15fvs1_ipatutch00364",
  "10399160726scl1cle1tr04nh02tr15s033_ipatukid00853",
  "10711160726scl1cle1ph08th07ha12rsb1_ipatugod00763",
  "10112150726scl1cle1tr04cu03ha12cbb1_ipatukid00850_prompt_1",
  "10112150726scl1cle1tr04cu03ha12cbb1_ipatukid00850_prompt_2",
  "10537160726scl1cle1tr04ha07tr15rsb1_ipatunbn00025",
  "10824170726scl1cle1tu08nh02ha12rsb1_ipatudog01238_prompt_1",
  "10441170726scl1cle1ph08nh02tr15sfb1_ipatugrm00417",
  "10390170726scl1cle1tr04th07li09pdo1_ipatuhut00475",
  "10661170726scl1cle1ph08cu03du10apt1_ipatuatm00035",
  "10395170726scl1cle1tu08cu03du10wfs1_ipatubsb00111_prompt_1",
  "10395170726scl1cle1tu08cu03du10wfs1_ipatubsb00111_prompt_2",
  "10898160726scl1cle1tu08ha07ha12sdt1_ipatudog01235",
  "10428170726scl1tmr1tr04nh02my04sdp1_ipatucps00114",
  "10380160726scl1cle1tu08cu03ha12cfc1_ipatudog01237",
  "10992170726scl1cle1tu08nh02du10qdb1_ipatublt00046",
  "10538160726scl1cle1tu08nh02tr15wfs1_ipatucat00138",
  "10394170726scl1cle1tu08cu03li09pdo1_ipatubkb00103",
  "10598170726scl1cle1ph08cu03my04srb1_ipatuwin00077",
  "10328160726scl1cle1tr04th07du10wlb1_ipatutch00365",
  "10618200726scl1cle1ph08ha07ha12anl1_ipatuslv00133",
  "10557200726scl1cle1tr04th07my04hsp1_ipatuwic00574",
  "10845200726scl1cle1ph08th07ha12hsp1_ipatugrm00418",
  "10317200726scl1cle1tr04nh02ha12rsb1_ipatukid00857_prompt_1",
  "10317200726scl1cle1tr04nh02ha12rsb1_ipatukid00857_prompt_2",
  "10187200726scl1cle1tr04nh02my04apt1_ipatubok00254",
  "10190150726scl1cle1tr04cu03du10qwh1_ipatuwic00563",
  "10911210726scl1cle1tu08cu03my04sdp1_ipatudog01241",
  "10624200726scl1cle1tr04ha07my04lla1_ipatukid00861",
  "10168210726scl1cle1ph08nh02my04afv1_ipatuwin00080",
  "10113140726scl1cle1tr04cu03ha12lto1_ipatubok00255",
  "10979210726scl1cle1ph08ha07ha12ckj1_ipatuclg00105",
  "10263210726scl1tmn1tr04nh02my04cbb1_ipatudsn22703",
  "10394200726scl1cle1tu08cu03du10sfb1_ipatudog01239",
  "10666200726scl1cle1tr04nh02ha12lto1_ipatunur00250",
  "10713210726scl1cle1tu08nh02my04apt1_ipatudog01246",
  "10159200726scl1cle1tu08nh02my04las1_ipatudog01240",
  "10793210726scl1cle1tr04cu03my04anl1_ipatuwic00576",
  "10309210726scl1cle1tu08ha07du10fvs1_ipatudog01243",
  "10923210726scl1cle1tr04th07li09fsp2_ipatukid00868",
  "10359210726scl1cle1tr04nh02tr15vjk1_ipatukid00867",
  "10300210726scl1cle1tr04ha07tr15sfb1_ipatubok00256",
  "10824170726scl1cle1tu08nh02ha12rsb1_ipatudog01238_prompt_2",
  "10435220726scl1cle1ph08nh02li09pdo1_ipatupto00149",
  "10902220726scl1cle1tr04nh02tr15apt1_ipatukid00872",
  "10702220726scl1cle1ph08cu03tr15qdb1_ipatuslv00134",
  "10462220726scl1cle1tr04ha07my04cwp1_ipatukid00873_prompt_1",
  "10462220726scl1cle1tr04ha07my04cwp1_ipatukid00873_prompt_2",
  "10246220726scl1cle1tu08ha07ha12wdc1_ipatudog01247",
  "10149210726scl1cle1tr04cu03tr15s029_ipatukid00862",
  "10372220726scl1cle1ph08nh02my04hsp1_ipatubak00180",
  "10120210726scl1cle1tr04cu03my04apt1_ipatukid00871",
  "10215220726scl1tmr1tr04nh02du10lsw1_ipatucps00115",
  "10772220726scl1cle1ph08th07my04qwh1_ipatubik00135",
  "10216220726scl1cle1tu08nh02my04blk1_ipatudog01248",
  "10891220726scl1cle1tu08cu03du10ccw1_ipatudth00378",
  "10803230726scl1cle1ph08cu03my04hsp1_ipatubrc00211",
  "10925230726scl1cle1ph08ha07ha12lto1_ipatuclg00106",
  "10358220726scl1cle1tr04th07ha12wtp1_ipatutch00418",
  "10326220726scl1cle1tr04cu03ha12aos1_ipatutch00420",
  "10740220726scl1cle1tu08ha07du10lsw1_ipatucat00139_prompt_1",
  "10740220726scl1cle1tu08ha07du10lsw1_ipatucat00139_prompt_2",
  "10826230726scl1cle1tr04cu03du10rsb1_ipatunur00251",
  "10622220726scl1tmr1tr04cu03ha13lsw1_ipatucps00116_single-rocker",
  "10622220726scl1tmr1tr04cu03ha13lsw1_ipatucps00116_single-toggle",
  "10550230726scl1cle1tu08ha07li09eep1_ipatudog01251",
  "10420220726scl1cle1tr04ha07ha12s029_ipatukid00877_prompt_1",
  "10420220726scl1cle1tr04ha07ha12s029_ipatukid00877_prompt_2",
  "10420220726scl1cle1tr04ha07ha12s029_ipatukid00877_prompt_3",
  "10420220726scl1cle1tr04ha07ha12s029_ipatukid00877_prompt_4",
  "10858230726scl1cle1tr04cu03my04sol1_ipatukid00880",
  "10602230726scl1cle1tr04ha07my04wcm1_ipatuwic00582",
  "10846230726scl1cle1tu08nh02li09str1_ipatudog01252",
  "10174230726scl1cle1tu08th07li09pdo1_ipatufsh00311",
  "10327230726scl1cle1ph08th07tr15lto1_ipatuslv00135",
  "10431230726scl1cle1ph08cu03li09eep1_ipatubid00325",
  "10440230726scl1cle1tr04ha07ha12wdc1_ipatuwic00581",
  "10955240726scl1cle1ph08nh02tr15twh1_ipatubet00211",
  "10321240726scl1cle1ph08cu03tr15sfb1_ipatubet00210",
  "10547240726scl1cle1ph08nh02li09dap1_ipatumrd00031",
  "10232240726scl1cle1tr04ha07my04hsp1_ipatusew00233_prompt_1",
  "10232240726scl1cle1tr04ha07my04hsp1_ipatusew00233_prompt_2",
  "10941240726scl1cle1tr04nh02ha12las1_ipatukid00895",
  "10307240726scl1cle1tr04cu03du10str1_ipatutch00422",
  "10100240726scl1cle1tu08th07du10tot1_ipatudog01254",
  "10755240726scl1cle1tr04th07my04hsp1_ipatuknt00007_prompt_1",
  "10755240726scl1cle1tr04th07my04hsp1_ipatuknt00007_prompt_2",
  "10755240726scl1cle1tr04th07my04hsp1_ipatuknt00007_prompt_3",
  "10755240726scl1cle1tr04th07my04hsp1_ipatuknt00007_prompt_4",
  "10755240726scl1cle1tr04th07my04hsp1_ipatuknt00007_prompt_5",
  "10577240726scl1cle1ph08nh02my01fsp2_ipatubid00326",
  "10440240726scl1cle1tr04nh02my01fsp2_ipatukid00886_prompt_1",
  "10440240726scl1cle1tr04nh02my01fsp2_ipatukid00886_prompt_2",
  "10440240726scl1cle1tr04nh02my01fsp2_ipatukid00886_prompt_3",
  "10440240726scl1cle1tr04nh02my01fsp2_ipatukid00886_prompt_4",
  "10440240726scl1cle1tr04nh02my01fsp2_ipatukid00886_prompt_5",
  "10440240726scl1cle1tr04nh02my01fsp2_ipatukid00886_prompt_6",
  "10192250726scl1cle1tu08th07my04dmt1_ipatudog01255",
  "10171250726scl1cle1tr04nh02ha12bsl1_ipatubok00257",
  "10602250726scl1cle1ph08nh02my04plp1_ipatumku00043",
  "10729240726scl1cle1ph08cu03ha12tbr1_ipatugrm00421",
  "10242240726scl1cle1tr04nh02tr15clc1_ipatukid00896",
  "10845250726scl1cle1tr04nh02tr15krd1_ipatukid00900",
  "10194250726scl1cle1tr04cu03tr15sco1_ipatuhll00029",
  "10301250726scl1cle1ph08cu03li09dap1_ipatubid00328",
  "10431250726scl1cle1tr04cu03du10tbl1_ipatucpl01231",
  "10711250726scl1cle1tr04cu03li09fsp2_ipatucpl01232",
  "10316250726scl1cle1tu08ha07li09fvs1_ipatudog01256",
  "10102270726scl1cle1tr04nh02ha12krd1_ipatukid00902",
  "10388270726scl1cle1tu08nh02ha12hdt1_ipatudog01259",
  "10978250726scl1cle1ph08cu03du10bsl1_ipatuwin00081",
  "10368270726scl1cle1ph08nh02li09smp1_ipatubid00331",
  "10600270726scl1cle1tu08th07du10hdt1_ipatudog01260",
  "10665270726scl1cle1tu08th07du10bsl1_ipatucat00142",
  "10405230726scl1cle1tr04cu03my04apt1_ipatukid00881",
  "10873270726scl1cle1tu08nh02my04sol1_ipatudog01263",
  "10234270726scl1cle1tu08ha07my04tph1_ipatudog01261",
  "10145270726scl1cle1tr04cu03li09kch1_ipatukid00904",
  "10268250726scl1cle1tu08ha07ha12las1_ipatudog01257",
  "10120280726scl1cle1ph08nh02du10eep1_ipatubrc00216",
  "10236270726scl1cle1tr04cu03du10blk1_ipatucpl01236",
  "10383280726scl1cle1tr04ha07ha12dwc1_ipatucpl01238",
  "GGS00000001scl1cle1tu08ph01ha13fsp2_ipatudth00242",
  "GGS00000002scl1cle1tu08ph01ha13fsp2_ipatudth00242",
  "GGS00000003scl1cle1tu08ph01ha13fsp2_ipatudth00242",
  "GGS00000004scl1cle1tu08ph01ha13fsp2_ipatudth00242",
  "GGS00000005scl1cle1tu08ph01ha13fsp2_ipatudth00242",
  "GGS00000006scl1cle1tu08ph01ha13fsp2_ipatudth00242",
  "10162280726scl1cle1tr04cu03my04ccw1_ipatuwic00591",
  "GGS00000007scl1cle1tu08ph01ha13fsp2_ipatudth00242",
  "GGS00000008scl1cle1tu08ph01ha13fsp2_ipatudth00242",
  "GGS00000009scl1cle1tu08ph01ha13fsp2_ipatudth00242",
  "GGS00000010scl1cle1tu08ph01ha13fsp2_ipatudth00242",
  "GGS00000011scl1cle1tu08ph01ha13fsp2_ipatudth00242",
  "GGS00000012scl1cle1tu08ph01ha13fsp2_ipatudth00242",
  "GGS00000013scl1cle1tu08ph01ha13fsp2_ipatudth00242",
  "GGS00000014scl1cle1tu08ph01ha13fsp2_ipatudth00242",
  "GGS00000015scl1cle1tu08ph01ha13fsp2_ipatudth00242",
  "GGS00000016scl1cle1tu08ph01ha13fsp2_ipatudth00242",
  "GGS00000017scl1cle1tu08ph01ha13fsp2_ipatudth00242",
  "GGS00000018scl1cle1tu08ph01ha13fsp2_ipatudth00242",
  "10884280726scl1cle1tr04nh02tr15vjk1_ipatukid00905"
]
}
